/**
 * @constant ai相关路由管理目录
 * @description 后续ai相关的业务，路由可以配置此处，方便统一管理。
 */
export const aiManager = [
  {
    path: '/aiManager/businessHelper',
    name: 'aiBusinessHelper',
    component: () => import('@/views/aiManager/businessHelper/index'),
    meta: {
      title: '经营助手',
      keepAlive: true
    }
  }
]
